import React from 'react'
import { RealEstateCategory, SegmentationType, TransactionType } from '../../../../../@types/types'
import { Flow, FlowName, FlowScreenElement } from '../../../../../@types/flow-types'
import { AGENT_PRODUCTION_HALL_RENT_FLOW_PATH } from '../../../../../services/routes/routes'
import {
  SCREEN_ADDRESS,
  SCREEN_API_SEARCH_DATA,
  SCREEN_CONNECTIONS,
  SCREEN_CONSTRUCTION,
  SCREEN_CONTACT_INFO,
  SCREEN_COSTS,
  SCREEN_DESCRIPTION,
  SCREEN_MULTIMEDIA,
  SCREEN_OBJECT_NUMBERS,
  SCREENS,
} from '../../../../../services/domain/wizardScreens'
import Address from '../../../../../components/pages/insertionPage/screens/address/Address'
import Description from '../../../../../components/pages/insertionPage/screens/description/Description'
import ContactInfo from '../../../../../components/pages/insertionPage/screens/contactInfo/ContactInfo'
import Multimedia from '../../../../../components/pages/insertionPage/screens/multimediaNew/Multimedia'

import Construction from '../../../../../components/pages/insertionPage/screens/construction/Construction'
import Connections from '../../../../../components/pages/insertionPage/screens/connections/Connections'
import { MultimediaUploaderType } from '../../../../../@types/multimedia-types'
import CommercialCostsRent from '../../../../../components/pages/insertionPage/screens/costs/wrappers/commercial/CommercialCostsRent'
import {
  hangarOtherFacilitiesScreen,
  hangarRentBasicInfoScreen,
} from '../../propertyOwner/hangar/propertyOwnerHangarRentFlow'
import { ObjectNumbersScreen } from '../../../../../components/pages/insertionPage/screens/objectNumber/ObjectNumbersScreen'
import ApiSearchData from '../../../../../components/pages/insertionPage/screens/apiSearchData/ApiSearchData'
import { agentProductionHallRentSchema } from './agentProductionHallRentSchema'
import { courtageInformationToApi } from '../../../../../api/realEstate/converters/toApi/estate/courtageInformation/courtageInformationToApi'
import { apiSearchDataToApi } from '../../../../../api/realEstate/converters/toApi/estate/apiSearchData/apiSearchDataToApi'

const agentProductionHallRentFlowScreens: FlowScreenElement[] = [
  {
    screen: SCREENS[SCREEN_ADDRESS],
    element: (props) => <Address {...props} />,
  },
  {
    screen: SCREENS[SCREEN_OBJECT_NUMBERS],
    element: (props) => <ObjectNumbersScreen {...props} />,
  },
  hangarRentBasicInfoScreen,
  {
    screen: SCREENS[SCREEN_COSTS],
    element: (props) => (
      <CommercialCostsRent
        {...props}
        hasMoveInDate={true}
        showCourtage
        screenTooltipKey='tooltip.screens.costs.allRent'
      />
    ),
  },
  {
    screen: SCREENS[SCREEN_DESCRIPTION],
    element: (props) => <Description {...props} hasLocationNote={true} hasOtherNote={true} />,
  },
  {
    screen: SCREENS[SCREEN_MULTIMEDIA],
    element: (props) => (
      <Multimedia
        {...props}
        doCloseMultimediaStatusMessage={props.doCloseMultimediaStatusMessage!}
        allowedTypesToDisplay={[
          MultimediaUploaderType.PICTURE,
          MultimediaUploaderType.FLOOR_PLAN,
          MultimediaUploaderType.DOCUMENT,
          MultimediaUploaderType.VIDEO,
        ]}
        allowMultimediaLinks
      />
    ),
  },
  hangarOtherFacilitiesScreen,
  {
    screen: SCREENS[SCREEN_CONNECTIONS],
    element: (props) => <Connections {...props} />,
  },
  {
    screen: SCREENS[SCREEN_CONSTRUCTION],
    element: (props) => <Construction {...props} hasLastModernizationField={true} />,
  },
  {
    screen: SCREENS[SCREEN_API_SEARCH_DATA],
    element: (props) => <ApiSearchData {...props} />,
  },
  {
    screen: SCREENS[SCREEN_CONTACT_INFO],
    element: (props) => <ContactInfo {...props} hasContactManager />,
  },
]

export const agentProductionHallRentFlow: Flow = {
  flowInformation: {
    owner: 'wizard.navigation.header.agent',
    estateType: 'wizard.navigation.header.hangar',
    offerType: 'wizard.navigation.header.rents',
    path: AGENT_PRODUCTION_HALL_RENT_FLOW_PATH,
    name: FlowName.AGENT_PRODUCTION_HALL_RENT,
    validationSchema: agentProductionHallRentSchema,
    courtageToApiMapper: courtageInformationToApi,
    apiSearchDataToApiMapper: apiSearchDataToApi,
    metaData: {
      category: RealEstateCategory.PRODUCTION_HALL,
      segmentation: SegmentationType.AGENT,
      transaction: TransactionType.RENT,
    },
  },
  defaultStateValues: {
    hideStreetAndStreetNumber: false,
  },
  flowScreens: agentProductionHallRentFlowScreens,
}
